import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge can't tell a design-kit font-size token from a text colour, so
// without this it files `text-caption-small` or `text-heading-md` under colours and
// silently drops it when a `text-<colour>` follows in the same call. Matched by family
// prefix rather than by a list of today's steps, so adding one can't quietly
// reintroduce the bug.
const isFontSize = (value: string) => /^(display|heading|body|caption)(-|$)/.test(value);

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [isFontSize] }],
      "font-weight": [{ font: ["regular", "heavy"] }]
    }
  }
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
